import { useEffect } from 'react';
import { Control, FieldValues, UseFormSetValue } from 'react-hook-form';

import lodash from 'lodash';

import { useCatalogueLabels } from 'hooks';

import { CheckboxWithControl } from 'components/CheckboxWithControl';

import * as S from './Checkboxes.styles';

type Category = { name: string; order: number };

type CheckboxesProps = {
  control: Control;
  data: Category[];
  values: string[];
  setValue: UseFormSetValue<FieldValues>;
};

export function Checkboxes(props: CheckboxesProps): React.ReactElement {
  const { control, data, values, setValue } = props;
  const { categoryLabel } = useCatalogueLabels();

  const checkifValuesIncludesAll = (checked: boolean, name: string) => {
    if (!checked && values.includes('ALL')) {
      const filteredValues = values
        .filter((value) => value !== 'ALL')
        .filter((value) => value !== name);
      setValue('category', filteredValues);
    }
  };

  const checkIfAllValuesSelected = (checked: boolean, name: string) => {
    if (checked) {
      const categories = data.map((category) => category.name);
      const valuesInstance = values;
      valuesInstance.unshift(name);

      const isValuesEqual = lodash.isEqual(categories.sort(), valuesInstance.sort());

      if (isValuesEqual) {
        valuesInstance.unshift('ALL');
        setValue('category', valuesInstance);
      }
    }
  };

  const selectAllValues = () => {
    if (values.includes('ALL')) {
      setValue('category', []);
      return;
    }

    const categories = data.map((item) => item.name);
    categories.unshift('ALL');
    setValue('category', categories);
  };

  const categoriesComponents = data?.map((item) => (
    <CheckboxWithControl
      key={item.name}
      control={control}
      name="category"
      label={categoryLabel(item.name)}
      checkboxValue={item.name}
      formValues={values}
      callback={(checked) => {
        checkIfAllValuesSelected(checked, item.name);
        checkifValuesIncludesAll(checked, item.name);
      }}
    />
  ));

  useEffect(() => {}, [values]);

  return (
    <S.Container>
      <CheckboxWithControl
        customOnChange={() => {
          selectAllValues();
        }}
        control={control}
        label="SELECT ALL"
        name="category"
        checkboxValue="ALL"
      />
      {categoriesComponents}
    </S.Container>
  );
}
